<div (click)="focus()" class="row pointer pointer-hover-blue m-1 p-2 background-light-gray rounded-2">
    <div class="col-2 m-auto">
        <app-gateway-svg
                [status]="status()"
                class="img-fluid img-max m-auto"></app-gateway-svg>
    </div>
    <div class="col-10 m-auto">
        <div class="row m-auto">
            <div class="fw-bold text-truncate">{{ gateway()?.name }}</div>
            <div class="{{ statusMessageColorClass() }}">{{ statusMessage() }}</div>
            @if (gateway()?.synchronizationStatus === SynchronizationStatus.syncPending) {
                <i class="fa-solid fa-hourglass-half color-warning"></i>
            }
        </div>
    </div>
</div>
